import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { restaurantInfo } from '../data/mockData';

const StickyMobileButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <a
      href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
      className={`md:hidden fixed bottom-6 right-6 z-50 bg-[#D4AF37] text-black p-4 rounded-full shadow-2xl transition-all duration-300 hover:bg-[#C5A028] hover:scale-110 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20 pointer-events-none'
      }`}
      aria-label="Appeler Le Cosmos"
    >
      <Phone size={24} className="animate-pulse" />
    </a>
  );
};

export default StickyMobileButton;
